import { Formie } from '../../../vendor/verbb/formie/src/web/assets/frontend/src/js/formie-lib'

export const initFormie = () => {
  
  const forms = document.querySelectorAll('.fui-form')

  if (!forms) return

  const FormieInstance = new Formie()

  forms.forEach(form => FormieInstance.initForm(form))

}

export default () => {} 